import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LoginComponent } from './components/login/login.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SignupComponent } from './components/signup/signup.component';
import { PersonaComponent } from './components/signup/persona/persona.component';
import { EmpresaComponent } from './components/signup/empresa/empresa.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

//animaciones angular material
import {MaterialModule} from './material';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';


import { HttpClientModule } from '@angular/common/http';
import { ProfileComponent } from './profile/profile.component';
import { Error404Component } from './components/error404/error404.component';
import { AdminComponent } from './components/admin/admin.component';
import { DataApiService } from './Services/data-api.service';
import { NuevoEnvioComponent } from './components/nuevo-envio/nuevo-envio.component';

import { ModificarPrecioComponent } from './components/dialogs/modificar-precio/modificar-precio.component';
import { AlertComponent } from './components/dialogs/alert/alert.component';
import { ActivarConveniosComponent } from './components/dialogs/activar-convenios/activar-convenios.component';
import { DialogCambiarEstadoConvenioComponent } from './components/dialogs/dialog-cambiar-estado-convenio/dialog-cambiar-estado-convenio.component';


import { PedidosService } from './Services/pedidos.service';

import { ReactiveFormsModule } from '@angular/forms';
import { DialogCopyPedidoComponent } from './components/dialogs/dialog-copy-pedido/dialog-copy-pedido.component';
import { DialogCrearCuentaSecundariaComponent } from './components/dialogs/dialog-crear-cuenta-secundaria/dialog-crear-cuenta-secundaria.component';
import { DialogLiquidacionComponent } from './components/dialogs/dialog-liquidacion/dialog-liquidacion.component';
import { CambiarPasswordComponent } from './components/cambiar-password/cambiar-password.component';

//ng-snotify
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { AlertRefreshComponent } from './components/dialogs/alert-refresh/alert-refresh.component';
import { VerDatosUsuarioPorServicioComponent } from './components/dialogs/ver-datos-usuario-por-servicio/ver-datos-usuario-por-servicio.component';
import { CrearUsuariosMototizadosComponent } from './components/dialogs/crear-usuarios-mototizados/crear-usuarios-mototizados.component';
import { VerUsuariosMototizadosComponent } from './components/dialogs/ver-usuarios-mototizados/ver-usuarios-mototizados.component';
import { AbrirAsignacionDeUsuariosComponent } from './components/dialogs/abrir-asignacion-de-usuarios/abrir-asignacion-de-usuarios.component';
import { InformacionPedidoComponent } from './components/dialogs/informacion-pedido/informacion-pedido.component';
import { MotorizadoComponent } from './motorizado/motorizado.component';
import { EditarServicioPorMotorizadoComponent } from './components/dialogs/editar-servicio-por-motorizado/editar-servicio-por-motorizado.component';

import {FileUploadService} from './Services/file-upload.service';
import { VerConstanciaComponent } from './components/dialogs/ver-constancia/ver-constancia.component';
import { DescargarReporteUsuarioComponent } from './components/dialogs/descargar-reporte-usuario/descargar-reporte-usuario.component';
import { VerConstanciasDeCargoComponent } from './components/dialogs/ver-constancias-de-cargo/ver-constancias-de-cargo.component';
import { ModificarUsuarioMotorizadoComponent } from './components/dialogs/modificar-usuario-motorizado/modificar-usuario-motorizado.component';

//hash
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { VerPerfilComponent } from './components/ver-perfil/ver-perfil.component';

//maps
import {MapsService} from './Services/maps.service';
import { VerUsuariosSecundariosComponent } from './components/dialogs/ver-usuarios-secundarios/ver-usuarios-secundarios.component';
import { ResumeComponent } from './components/resume/resume.component';
import { RegionComponent } from './region/region.component';
import { CodigoDescuentoComponent } from './components/dialogs/codigo-descuento/codigo-descuento.component';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { AltaDemandaComponent } from './components/dialogs/alta-demanda/alta-demanda.component';
import { RouterModule } from '@angular/router';
import { MapAdminComponent } from './components/map-admin/map-admin.component';
import { VerUsuariosComponent } from './components/ver-usuarios/ver-usuarios.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NavbarComponent,
    SignupComponent,
    PersonaComponent,
    EmpresaComponent,
    ProfileComponent,
    Error404Component,
    AdminComponent,
    NuevoEnvioComponent, 
    ModificarPrecioComponent,
    AlertComponent,
    ActivarConveniosComponent,
    DialogCambiarEstadoConvenioComponent,
    NuevoEnvioComponent,
    DialogCopyPedidoComponent,
    DialogCrearCuentaSecundariaComponent,
    DialogLiquidacionComponent,
    CambiarPasswordComponent,
    AlertRefreshComponent,
    VerDatosUsuarioPorServicioComponent,
    CrearUsuariosMototizadosComponent,
    VerUsuariosMototizadosComponent,
    AbrirAsignacionDeUsuariosComponent,
    InformacionPedidoComponent,
    MotorizadoComponent,
    EditarServicioPorMotorizadoComponent,
    VerConstanciaComponent,
    DescargarReporteUsuarioComponent,
    VerConstanciasDeCargoComponent,
    ModificarUsuarioMotorizadoComponent,
    VerPerfilComponent,
    VerUsuariosSecundariosComponent,
    ResumeComponent,
    RegionComponent,
    CodigoDescuentoComponent,
    AltaDemandaComponent,
    ResumeComponent,
    MapAdminComponent,
    VerUsuariosComponent
   
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MaterialModule,
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
    SnotifyModule,
    GooglePlaceModule,
    
  ],
  exports:  [ CommonModule,],

  providers: [DataApiService,PedidosService,
  { provide: 'SnotifyToastConfig', useValue: ToastDefaults},
  SnotifyService,FileUploadService,
  /*{provide: LocationStrategy, useClass: HashLocationStrategy},*/
  MapsService],

  bootstrap: [AppComponent],

  entryComponents:[
    ModificarPrecioComponent,
    AlertComponent,
    AlertRefreshComponent,
    ActivarConveniosComponent,
    DialogCambiarEstadoConvenioComponent,
    DialogCopyPedidoComponent,
    DialogCrearCuentaSecundariaComponent,
    DialogLiquidacionComponent,
    VerDatosUsuarioPorServicioComponent,
    CrearUsuariosMototizadosComponent,
    VerUsuariosMototizadosComponent,
    AbrirAsignacionDeUsuariosComponent,
    InformacionPedidoComponent,
    EditarServicioPorMotorizadoComponent,
    VerConstanciaComponent,
    DescargarReporteUsuarioComponent,
    VerConstanciasDeCargoComponent,
    ModificarUsuarioMotorizadoComponent,
    VerPerfilComponent,
    VerUsuariosSecundariosComponent,
    CodigoDescuentoComponent,
    ResumeComponent,
    AltaDemandaComponent

  ]
})
export class AppModule { }
